export default "/images/a05010d7fd41404411ab2fae0c437137.avif";